import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';

export const TextRow = ({ header, isRequired, children }) => {
  return (
    <TblRow>
      <TblRowHeader rowHeader={i18n.t(header)} isRequired={isRequired} />
      <TblRowTail>{children}</TblRowTail>
    </TblRow>
  );
};
TextRow.propTypes = {
  children: PropTypes.node,
  header: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
};
TextRow.defaultProps = { children: <></>, isRequired: false };
export default TextRow;
